import { render, staticRenderFns } from "./video.vue?vue&type=template&id=aa7a77e8&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=aa7a77e8&lang=scss&scoped=true&"
import style1 from "./video.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7a77e8",
  null
  
)

export default component.exports